import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { CommonUtil } from "app/utils/common.util";
import { UrlUtil } from "app/utils/url.util";
import { of } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable()
export class DocumentSignatureService {
  constructor(
    private http: HttpClient,
    private urlUtil: UrlUtil,
    private commonUtil: CommonUtil,
    private _translateService: TranslateService
  ) {}

  public getDocumentSignatureList() {
    return this.http
      .get(this.urlUtil.getUrl("documentSignature", "getAll").replace("$ORGANISATION_ID", this.commonUtil.getUserDetail("organisationId")))
      .pipe(
        map((resp: any) => {
          if (resp.status) {
            return resp.data;
          } else {
            return [];
          }
        }),
        catchError((e) => {
          console.log("getDocumentSignatureList() Error", e);
          return of([]);
        })
      );
  }

  public saveDocumentSignatureList(data) {
    return this.http.post(this.urlUtil.getUrl("documentSignature", "add"), data).pipe(
      map((resp: any) => {
        const { status, jsonData, errorMessage } = resp;
        if (status) {
          return {
            status: status,
            message: this._translateService.instant("DataAddSuccess")
          };
        } else {
          return {
            status: false,
            message: errorMessage || jsonData || this._translateService.instant("FailDataAdd")
          };
        }
      }),
      catchError((e) => {
        console.log(e);
        return of({
          status: false,
          message: this._translateService.instant("FailDataAdd")
        });
      })
    );
  }

  public updateDocumentSignature(data) {
    return this.http.put(this.urlUtil.getUrl("documentSignature", "update").replace("$ID", data.id), data).pipe(
      map((resp: any) => {
        const { status, jsonData, errorMessage } = resp;
        if (status) {
          return {
            status: status,
            message: this._translateService.instant("DataUpdateSuccess")
          };
        } else {
          return {
            status: false,
            message: errorMessage || jsonData || this._translateService.instant("FailDataUpdate")
          };
        }
      }),
      catchError((e) => {
        console.log(e);
        return of({
          status: false,
          message: this._translateService.instant("FailDataUpdate")
        });
      })
    );
  }

  public getDocumentSignatureById(id: string = null) {
    return this.http.get(this.urlUtil.getUrl("documentSignature", "searchById").replace("$ID", id)).pipe(
      map((resp: any) => {
        if (resp.status) {
          return resp.data;
        } else {
          return {};
        }
      }),
      catchError((e) => {
        console.log("getDocumentSignatureById error =>", e);
        return of({});
      })
    );
  }

  public searchDocumentSignatureByFields(data) {
    const url = this.urlUtil.getUrl("documentSignature", "searchByField");
    return this.http
      .post(url, {
        key: data.key,
        value: data.value,
        pageNumber: data.pageNumber,
        pageSize: data.pageSize,
        sortBy: data.sortBy,
        sortDirection: data.sortDirection
      })
      .pipe(
        map((resp: any) => {
          if (resp.status) {
            return resp.data;
          } else {
            return [];
          }
        }),
        catchError((e) => {
          console.log(e);
          return of([]);
        })
      );
  }

  public deleteDocumentSignature(ids) {
    return this.http.post(this.urlUtil.getUrl("documentSignature", "delete"), ids).pipe(
      map((resp: any) => {
        const { status, jsonData, errorMessage, data } = resp;
        if (status && ids.length === data.deletedId?.length) {
          return {
            status: status,
            message: this._translateService.instant("DataDeleteSuccess")
          };
        } else {
          return {
            status: false,
            message: errorMessage || jsonData || this._translateService.instant("FailDataDelete")
          };
        }
      }),
      catchError((e) => {
        console.log(e);
        return of({
          status: false,
          message: this._translateService.instant("FailDataDelete")
        });
      })
    );
  }

  public resendDocumentSignatureList(id: any) {
    return this.http.post(this.urlUtil.getUrl("documentSignature", "resend").replace("$ID", id), null).pipe(
      map((resp: any) => {
        const { status, jsonData, errorMessage } = resp;
        if (status) {
          return {
            status: status,
            message: errorMessage || jsonData || this._translateService.instant("Notification send successfully!")
          };
        } else {
          return {
            status: false,
            message: errorMessage || jsonData || this._translateService.instant("Not able to send notification!")
          };
        }
      }),
      catchError((e) => {
        console.log(e);
        return of({
          status: false,
          message: this._translateService.instant("ErrorGeneral")
        });
      })
    );
  }

  public refreshSignatureStatus(id: string = null) {
    return this.http.get(this.urlUtil.getUrl("documentSignature", "refresh").replace("$ID", id)).pipe(
      map((resp: any) => {
        if (resp.status) {
          return resp;
        } else {
          return [];
        }
      }),
      catchError((e) => {
        console.log("getDocumentSignatureById error =>", e);
        return of([]);
      })
    );
  }
}
